// Lucide icon: circle-check (https://lucide.dev/icons/circle-check)
import { CircleCheck } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconApproved = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <CircleCheck />
    </IconComponentStyled>
  )
}
